import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { DocumentManagementClient } from './document-management-client.js';

export function useDocumentManagementClient(): DocumentManagementClient {
  const httpClient = useHttpClient({ type: 'editor' });
  const client = useMemo(
    () => new DocumentManagementClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
